module.exports = __webpack_public_path__ + "static/media/cimb.def826e6.svg";